<template>
  <div class="driver-income-page" v-loading="loading">
    <!-- 收入统计卡片 -->
    <div class="stats-cards">
      <div class="stat-card total">
        <div class="card-label">累计总收入</div>
        <div class="card-value money">￥{{ formatAmount(income.totalIncome) }}</div>
      </div>
      <div class="stat-card">
        <div class="card-label">顺风车收入</div>
        <div class="card-value">￥{{ formatAmount(income.hitchRideIncome) }}</div>
        <div class="card-sub">{{ income.hitchRideOrderCount || 0 }} 单</div>
      </div>
      <div class="stat-card">
        <div class="card-label">班车收入</div>
        <div class="card-value">￥{{ formatAmount(income.busIncome) }}</div>
        <div class="card-sub">{{ income.busOrderCount || 0 }} 单</div>
      </div>
      <div class="stat-card">
        <div class="card-label">累计总订单</div>
        <div class="card-value">{{ income.totalOrderCount || 0 }}</div>
        <div class="card-sub">单</div>
      </div>
    </div>

    <!-- 评价列表 -->
    <div class="section-title">乘客评价记录</div>
    <el-table :data="evaluates" v-loading="evalLoading" size="small" stripe border>
      <el-table-column label="评分" prop="score" width="80" align="center">
        <template slot-scope="{ row }">
          <el-rate :value="row.score" disabled size="small" />
        </template>
      </el-table-column>
      <el-table-column label="评价内容" prop="detail" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.detail">{{ row.detail }}</span>
          <span v-else class="util-remark">暂无文字评价</span>
        </template>
      </el-table-column>
      <el-table-column label="评价时间" prop="created" width="150">
        <template slot-scope="{ row }">{{ row.created | filterTime }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      background
      layout="total, prev, pager, next"
      :total="evalPage.total"
      :current-page.sync="evalPage.page"
      :page-size="evalPage.size"
      @current-change="loadEvaluates"
    />
  </div>
</template>

<script>
export default {
  name: 'DriverIncomePage',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      income: {},
      evaluates: [],
      evalLoading: false,
      evalPage: { page: 1, size: 10, total: 0 }
    }
  },
  created() {
    this.loadIncome()
    this.loadEvaluates()
  },
  methods: {
    async loadIncome() {
      if (!this.info || !this.info.id) return
      this.loading = true
      const res = await this.$axios.get(`/api/v1/manage/driver/${this.info.id}/income`)
      if (res && res.code === 1 && res.data) {
        this.income = res.data
      }
      this.loading = false
    },
    async loadEvaluates(page = 1) {
      if (!this.info || !this.info.id) return
      this.evalLoading = true
      this.evalPage.page = page
      const res = await this.$axios.get(`/api/v1/manage/driver/${this.info.id}/evaluates`, {
        page: this.evalPage.page,
        size: this.evalPage.size
      })
      if (res && res.code === 1 && res.data) {
        this.evaluates = res.data.records || []
        this.evalPage.total = res.data.total || 0
      }
      this.evalLoading = false
    },
    formatAmount(val) {
      if (val === null || val === undefined) return '0.00'
      return Number(val).toFixed(2)
    }
  }
}
</script>

<style lang="less" scoped>
.driver-income-page {
  .stats-cards {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .stat-card {
      flex: 1;
      min-width: 140px;
      background: #f8f9fb;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #EBEEF5;

      &.total {
        background: linear-gradient(135deg, #409EFF, #79bbff);
        border: none;
        .card-label { color: rgba(255,255,255,0.85); }
        .card-value { color: #fff; }
      }

      .card-label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 6px;
      }

      .card-value {
        font-size: 22px;
        font-weight: 700;
        color: #303133;
        &.money { color: #E6A23C; }
      }

      .card-sub {
        font-size: 12px;
        color: #C0C4CC;
        margin-top: 4px;
      }
    }
  }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #409EFF;
  }

  .pagination {
    margin-top: 12px;
    text-align: right;
  }

  .util-remark {
    color: #C0C4CC;
    font-size: 12px;
  }
}
</style>
